import { MODAL_ELEMENT_ID_PREFIX } from "Common/componentUtils/constants";
import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import chroma from "chroma-js";
import themeVariables from "../themeVariables";
import SIZES from "./sizes";
import { locale } from "Common/dxLocalization";
import { css } from "styled-components";
const dataGridCellSelector = ".dx-datagrid .dx-row.dx-data-row > td:not(.dx-command-select):not(.dx-editor-cell)";
export const dxBaseStyles = css `
  .dx-gesture-cover {
    top: unset;
    bottom: unset;
    left: unset;
    right: unset;
  }
  .dx-widget:not(.dx-button),
  .dx-overlay-wrapper,
  .dx-menu-base,
  .dx-datagrid-filter-row .dx-menu .dx-overlay-content,
  .dx-tab,
  .dx-tab-text {
    font-family: ${themeVariables["font-family-base"]};
    line-height: ${themeVariables["line-height-base"]};
    font-size: inherit;
    color: ${themeVariables["text-color"]};
    font-weight: 400;
  }
  a.dx-widget {
    text-decoration: none;
    font-weight: 400;
    &:active,
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

  .dx-dropdowneditor-icon,
  .dx-numberbox-spin-down-icon,
  .dx-treeview-toggle-item-visibility,
  .dx-list .dx-empty-message,
  .dx-list-item,
  .dx-calendar-cell,
  .dx-texteditor-input,
  .dx-popup-title {
    color: ${themeVariables["text-color"]};
  }

  .dx-overlay-wrapper input,
  .dx-overlay-wrapper textarea,
  .dx-widget input,
  .dx-widget textarea {
    font-family: ${themeVariables["font-family-base"]};
    font-size: ${themeVariables["font-size-base"]};
    line-height: ${themeVariables["line-height-texteditor"]};
    font-weight: 400;
  }
  .dx-overlay-wrapper input,
  .dx-overlay-wrapper textarea,
  .dx-texteditor-input {
    border-radius: ${themeVariables["border-radius-small"]};
  }

  .dx-widget {
    &.text-left > ${dataGridCellSelector} {
      text-align: left !important;
    }
    &.text-right > ${dataGridCellSelector} {
      text-align: right !important;
    }
    &.text-center > ${dataGridCellSelector} {
      text-align: center !important;
    }

    &.font-base > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-base"]} !important;
    }
    &.font-small > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-small"]} !important;
    }
    &.font-smallest > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-smallest"]} !important;
    }
    &.font-h1 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h1"]} !important;
    }
    &.font-h2 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h2"]} !important;
    }
    &.font-h3 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h3"]} !important;
    }
    &.font-h4 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h4"]} !important;
    }
    &.font-h5 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h5"]} !important;
    }
    &.font-h6 > ${dataGridCellSelector} {
      font-size: ${themeVariables["font-size-h6"]} !important;
    }
  }

  .dx-placeholder:before {
    padding: 7px 12px 6px;
    font-size: ${themeVariables["font-size-base"]};
    font-weight: 400;
  }
  textarea.dx-texteditor-input {
    padding-top: 8.6px;
    padding-bottom: 7px;
  }
  textarea.dx-texteditor-input + .dx-placeholder:before {
    padding-top: 7.2px;
    padding-bottom: 7px;
  }
  .dx-texteditor-input.dx-placeholder-inherit + .dx-placeholder:before {
    padding-top: inherit;
    padding-bottom: inherit;
    line-height: inherit;
    margin-bottom: -2px;
  }

  .dx-texteditor-input {
    min-height: unset;
    padding-top: 9px;
    padding-left: 12px;
    padding-right: 12px;
    line-height: ${themeVariables["line-height-texteditor"]};
  }

  .box-with-text-editor-paddings {
    min-height: ${themeVariables["input-height-base"]};
    padding: 8px 12px 8px 12px !important;
    line-height: ${themeVariables["line-height-texteditor"]};
  }

  .dx-texteditor.dx-editor-outlined,
  .text-editor-wrapper-imitation {
    box-shadow: ${themeVariables["input-shadow"]};
    border-radius: ${themeVariables["border-radius-small"]};
    &.error {
      border-color: ${themeVariables["input-border-error"]};
    }

    &.dx-state-focused {
      background-color: ${themeVariables["input-bg-focus"]};
    }

    .dx-texteditor-container {
      cursor: text;
    }

    &.darker-texteditor {
      border: 1px solid ${themeVariables["gray-600"]};
      background-color: ${themeVariables["gray-600"]};
      color: ${themeVariables["gray-400"]};
      input,
      textarea {
        color: ${themeVariables["gray-400"]};
      }
    }

    &.darkest-texteditor {
      border: 1px solid ${themeVariables["gray-650"]};
      background-color: ${themeVariables["gray-650"]};
      color: ${themeVariables["gray-400"]};
      input,
      textarea {
        color: ${themeVariables["gray-400"]};
      }
    }
  }

  .dx-editor-cell .dx-texteditor.dx-editor-outlined {
    border-radius: 0;
  }

  .dx-icon-eye:before {
    content: "\\e90c";
    font: ${themeVariables["icomoon-icons"]};
    font-size: 16px !important;
  }

  .dx-icon-eye-slash:before {
    content: "\\e90d";
    font: ${themeVariables["icomoon-icons"]};
    font-size: 16px !important;
  }

  .dx-show-clear-button .dx-icon-clear {
    color: ${themeVariables["default-icon-color"]};
    font-size: 20px;
    line-height: 20px;
    transition: opacity 0.15s;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }

  .dx-show-clear-button .dx-clear-button-area {
    width: 46px;
    min-width: 46px;
  }

  .dx-show-clear-button.dx-texteditor:not(.dx-texteditor-empty):not(.dx-tagbox):not(.dx-selectbox) {
    .dx-clear-button-area {
      width: 36px;
      min-width: 36px;
      display: grid;
      align-content: center;
      justify-content: center;

      .dx-icon.dx-icon-clear {
        border-radius: 50%;
        transition: opacity 0.15s;
        opacity: 0.8;
        width: 20px;
        height: 20px;
        border: none;
        background: transparent;
        position: relative;
        top: auto;
        margin: 0;
        padding: 2px;

        &:hover {
          opacity: 1;
        }
        &:before {
          font: ${themeVariables["icomoon-icons"]};
          content: "\\e973";
          border-radius: 50%;
          top: calc(50% - 6px);
          left: calc(50% - 6px);
          margin: 0;
          width: 16px;
          height: 16px;
          position: absolute;
          transform: none;
          background: none;
        }
      }
    }

    .dx-texteditor-input {
      padding-right: 4px;
    }
  }

  .dx-dropdowneditor-field-template-wrapper {
    max-width: 100%;
  }

  .hide-invalid-badge.dx-texteditor.dx-invalid .dx-texteditor-input {
    padding-right: 0;
  }
  .hide-invalid-badge.dx-invalid.dx-texteditor.dx-editor-outlined.dx-show-invalid-badge
    .dx-texteditor-input-container:after {
    width: 0;
    height: 0;
    display: none;
  }

  .dx-invalid.dx-texteditor,
  .dx-invalid.dx-texteditor.dx-datebox {
    border-color: ${themeVariables["brand-danger-400"]};
    .dx-invalid-message.dx-overlay-wrapper {
      visibility: visible;
    }
  }

  .dx-invalid.dx-texteditor.dx-editor-filled.dx-show-invalid-badge
    .dx-texteditor-input-container:after,
  .dx-invalid.dx-texteditor.dx-editor-outlined.dx-show-invalid-badge
    .dx-texteditor-input-container:after,
  .dx-invalid.dx-texteditor.dx-editor-underlined.dx-show-invalid-badge
    .dx-texteditor-input-container:after {
    display: none;
  }

  .dx-overlay.dx-invalid-message-bottom.dx-visibility-change-handler {
    position: relative;
    > :first-child {
      right: 0 !important;
      width: 100% !important;
      transform: none !important;
      > :first-child {
        max-width: 100% !important;
        right: 1px;
        top: -2px !important;
        left: auto !important;
        transform: none !important;
      }
    }
  }

  .tooltip-invalid-message > .dx-overlay-content,
  .dx-invalid-message > .dx-overlay-content {
    background-color: ${themeVariables["brand-danger-100"]};
    border: none !important;
    box-shadow: 0px 2px 4px -2px rgba(45, 45, 45, 0.2) !important;
    color: ${themeVariables["brand-danger-400"]};
    border-radius: ${themeVariables["border-radius-small"]} !important;
    font-size: ${themeVariables["font-size-small"]};
    padding: 0.3em 0.5em;
    line-height: ${themeVariables["line-height-medium"]};
    opacity: 0.85;
    &:hover {
      opacity: 1;
    }
    > .dx-popup-content {
      padding: 0 !important;
      height: auto !important;
    }
  }

  .dx-treeview-toggle-item-visibility:before,
  .dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened:before {
    margin-top: -9px;
  }

  .dx-tabpanel > .dx-tabpanel-tabs dx.item-content .dx-tab-content {
    padding: 0 ${themeVariables["padding-xs"]};
  }

  .dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
    right: 3px;
    height: 2em;
    top: 7px;
  }

  .dx-menu-base
    .dx-menu-item
    .dx-menu-item-content
    .dx-menu-item-popout-container
    .dx-menu-item-popout {
    &:before {
      color: ${themeVariables["gray-500"]};
      content: "\\e902";
      display: block;
      transform: rotate(180deg);
      font: ${themeVariables["icomoon-icons"]};
      font-size: 16px;
      width: 16px;
      font-weight: 500;
      transition: all 0.2s linear;
    }
  }

  .dx-menu-base
    .dx-menu-item.dx-menu-item-expanded
    .dx-menu-item-content
    .dx-menu-item-popout-container
    .dx-menu-item-popout {
    &:before {
      transform: rotate(0deg);
    }
  }
`;
export const dxTagBox = css `
  .dx-tag {
    min-height: 40px;
    padding-right: 10px;
  }
  .dx-tag-content {
    padding: 0 32px 0 10px;
    min-height: 34px;
    margin: 11px 2px 11px 0;
    display: inline-flex;
    max-width: 100%;
    background-color: transparent !important;
    color: ${themeVariables["text-color"]};

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-grid;
      align-content: center;
      max-width: 100%;
      white-space: nowrap;
    }
  }
  .dx-tag-container.dx-texteditor-input-container {
    padding: 0 0 0 14px;
    .dx-texteditor-input {
      min-height: 40px;
      padding-top: 4px;
      padding-left: 10px;
    }
    .dx-placeholder:before {
      padding-top: 6px;
      padding-left: 24px;
    }
  }
  .dx-tagbox {
    overflow: hidden;

    .dx-tag-remove-button {
      border-radius: 50%;
      transition: opacity 0.15s;
      opacity: 0.6;
      width: 16px;
      height: 16px;
      border: none;
      background: transparent;
      transform: translateY(-50%);
      top: 50%;

      &:hover {
        opacity: 1;
      }
      &:before {
        font: ${themeVariables["icomoon-icons"]};
        content: "\\e973";
        border-radius: 50%;
        top: calc(50% - 6px);
        left: calc(50% - 6px);
        margin: 0;
        width: 12px;
        height: 12px;
        position: absolute;
        transform: none;
      }
      &:after {
        content: "";
        display: none;
      }
    }
  }
  .dx-tagbox:not(.dx-texteditor-empty) .dx-texteditor-input {
    padding-left: 10px;
    margin-left: 0;
  }
  .dx-tagbox:not(.dx-tagbox-single-line) .dx-texteditor-input-container {
    overflow: hidden;
  }
`;
export const dxCheckBox = css `
  .dx-list-item-before-bag .dx-list-select-checkbox {
    margin-bottom: 0;
  }
  .dx-list-select-all-checkbox {
    margin-top: 1px;
  }
  .dx-widget.dx-checkbox {
    display: inline-grid;
    line-height: ${SIZES.CHECK_BOX_SIZE}px;
    color: ${themeVariables["gray-700"]};
  }

  .dx-checkbox .dx-checkbox-icon {
    width: ${SIZES.CHECK_BOX_SIZE}px;
    height: ${SIZES.CHECK_BOX_SIZE}px;
    border-radius: 4px;
  }

  .dx-checkbox.checkbox-small .dx-checkbox-icon {
    width: ${SIZES.CHECK_BOX_SIZE_SMALL}px;
    height: ${SIZES.CHECK_BOX_SIZE_SMALL}px;
    border-radius: 2px;
  }

  .dx-widget.dx-checkbox.nowrap .dx-checkbox-text {
    white-space: nowrap !important;
  }

  .dx-widget.dx-checkbox .dx-checkbox-text {
    padding-left: 10px;
  }

  .dx-checkbox-icon {
    border-color: ${themeVariables["gray-100"]};
  }
  .dx-checkbox-checked .dx-checkbox-icon {
    background-color: ${themeVariables["brand-primary-500"]};
    color: #fff;
    border-color: ${themeVariables["brand-primary-500"]} !important;
    font-size: ${themeVariables["font-size-small"]};
  }
  .dx-checkbox.dx-state-hover .dx-checkbox-icon {
    border-color: ${themeVariables["brand-primary-500"]};
  }
  .dx-checkbox.dx-state-focused .dx-checkbox-icon {
    border-color: ${themeVariables["gray-100"]};
  }

  .dx-checkbox-indeterminate .dx-checkbox-icon {
    font-size: 10px;
    border-color: ${themeVariables["brand-primary-500"]} !important;
    &:before {
      background-color: ${themeVariables["brand-primary-500"]} !important;
    }
  }
  .dx-widget.dx-checkbox.checkbox-small .dx-checkbox-text {
    padding-left: 7px;
    font-size: ${themeVariables["font-size-small"]};
  }
  .dx-widget.dx-checkbox.checkbox-small .dx-checkbox-icon {
    font-size: ${themeVariables["font-size-smallest"]} !important;
  }

  .dx-treeview.checkbox-disabled .dx-checkbox {
    pointer-events: none;
  }

  .dx-treeview-toggle-item-visibility ~ .dx-treeview-node-container {
    padding-left: 26px;
  }

  .dx-treeview-item-with-checkbox .dx-checkbox {
    left: ${Math.floor(SIZES.CHECK_BOX_SIZE * 0.5)}px;
    top: ${Math.floor(SIZES.CHECK_BOX_SIZE * 0.5)}px;
  }
  .dx-treeview-item-with-checkbox.dx-treeview-node-is-leaf .dx-checkbox {
    top: calc(50% - ${Math.floor(SIZES.CHECK_BOX_SIZE / 2)}px);
  }
  .dx-treeview-item-without-checkbox .dx-treeview-item {
    font-size: ${themeVariables["font-size-base"]};
    font-weight: 400;
  }
  .dx-treeview-item-without-checkbox {
    > .dx-treeview-item.dx-state-hover {
      background-color: ${themeVariables["dropdown-link-hover-bg"]};
      color: ${themeVariables["dropdown-link-hover-color"]};
    }
    &.dx-state-focused,
    &.dx-state-selected {
      > .dx-treeview-item {
        background-color: ${themeVariables["dropdown-link-active-bg"]};
        color: ${themeVariables["dropdown-link-active-color"]};
      }
    }
  }

  .dx-treeview .dx-treeview-node {
    padding-left: 0;
  }

  .dx-filterbuilder-overlay .dx-treeview .dx-treeview-node.dx-treeview-item-without-checkbox {
    padding-left: 0;
  }

  .dx-checkbox.dx-checkbox-indeterminate .dx-checkbox-container .dx-checkbox-icon {
    border-color: ${themeVariables["gray-200"]} !important;
    font-size: 10px;
  }

  .dx-checkbox .dx-checkbox-container .dx-checkbox-icon {
    border-color: ${themeVariables["checkbox-border-color"]} !important;
    font-size: 16px;
    &:before {
      border-radius: 0;
      background-color: ${themeVariables["checkbox-checked-bg"]} !important;
      position: absolute;
    }
  }
  .dx-checkbox.dx-checkbox-checked .dx-checkbox-container .dx-checkbox-icon {
    background-color: ${themeVariables["checkbox-checked-bg"]};
    color: ${themeVariables["checkbox-checked-color"]} !important;
    border-color: ${themeVariables["checkbox-checked-border-color"]} !important;
    font-size: 12px;
  }
  .dx-treeview .dx-treeview-node .dx-treeview-toggle-item-visibility {
    left: unset;
    right: ${Math.floor(SIZES.CHECK_BOX_SIZE * 0.25)}px;
    top: ${Math.floor(SIZES.CHECK_BOX_SIZE * 0.1)}px;

    &:before {
      content: "\\e902";
      font: ${themeVariables["icomoon-icons"]};
      color: ${themeVariables["gray-400"]} !important;
      font-size: 16px;
      transform: rotate(180deg);
    }
  }
  .dx-treeview
    .dx-treeview-node
    .dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened {
    &:before {
      transform: rotate(0deg);
    }
  }
`;
export const dxRadioButton = css `
  .dx-list-item-before-bag .dx-list-select-radiobutton {
    margin-bottom: 0;
  }
  .dx-radio-value-container {
    padding-right: 8px;
  }
  .dx-radiobutton {
    line-height: inherit;
  }
  .dx-radiobutton-icon {
    width: ${SIZES.RADIO_BUTTON_ICON_SIZE}px;
    height: ${SIZES.RADIO_BUTTON_ICON_SIZE}px;
    box-sizing: content-box;
    border: ${themeVariables["radiobutton-border"]};
    border-radius: 50%;
    background: transparent !important;
    position: relative;
  }
  .dx-radiobutton-icon:before {
    display: none;
  }
  .dx-radiobutton-icon.dx-radiobutton-icon-checked {
    border: ${themeVariables["radiobutton-border-checked"]};
  }

  .dx-radiobutton.dx-state-hover,
  .dx-radiobutton.dx-state-focused {
    .dx-radiobutton-icon:not(.dx-radiobutton-icon-checked) {
      border-color: ${themeVariables["radiobutton-border-hover"]} !important;
    }
    .dx-radiobutton-icon.dx-radiobutton-icon-checked {
      border-color: ${themeVariables["radiobutton-border-color-checked"]} !important;
    }
  }
  .dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${themeVariables["radiobutton-bg-checked"]} !important;
    margin: 0;
    border-width: 3px !important;
  }

  .dx-popup-wrapper.dark-popover > .dx-overlay-content .dx-popup-content {
    .dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
      border: 2px solid ${themeVariables["dark-popover-bg"]};
      background-color: ${themeVariables["dark-popover-bg"]};
    }
    .dx-radiobutton-icon.dx-radiobutton-icon-checked {
      border: ${themeVariables["radiobutton-border-checked"]};
    }
  }
`;
export const dxTreeView = css `
  .dx-treeview-item {
    min-height: ${SIZES.CHECK_BOX_SIZE * 2}px;
  }
  .dx-treeview-item-with-checkbox .dx-treeview-item {
    padding-left: ${SIZES.CHECK_BOX_SIZE * 1.9}px;
    color: ${themeVariables["text-color"]};
  }
  .dx-treeview-node-container {
    font-size: 16px;
  }
  .dx-treeview-node-container-opened .dx-treeview-item-content {
    font-size: 14px;
    padding-top: 2px;
  }

  .dx-treeview-node-is-leaf .dx-treeview-item-content {
    font-size: 12px;
    padding-top: 4px;
  }

  .dx-treeview .dx-empty-message {
    color: ${themeVariables["gray-400"]};
    font-size: 1.2em;
    line-height: 1.4em;
    text-align: center;
  }
  .dx-toolbar .dx-treeview .dx-empty-message {
    font-size: inherit;
    line-height: 1.5;
  }
`;
export const dxOverlay = css `
  .dx-overlay-wrapper {
    font-family: ${themeVariables["font-family-base"]};
    line-height: ${themeVariables["line-height-base"]};
    font-weight: 500;
  }
  .dx-overlay-wrapper,
  .dx-popup-title.dx-toolbar .dx-toolbar-label {
    font-size: ${themeVariables["font-size-base"]};
    color: ${themeVariables["text-color"]};
  }

  .dx-overlay-wrapper.dark,
  .dx-popup-title.dx-toolbar.dark,
  .dx-toolbar-label {
    font-size: ${themeVariables["font-size-base"]};
    color: ${themeVariables["dark-popover-color"]};
  }

  .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button .dx-button-content,
  .dx-toolbar-menu-section .dx-toolbar-item-auto-hide {
    padding: 0 !important;
  }

  .dx-popup-wrapper > .dx-overlay-content,
  .dx-popover-wrapper > .dx-overlay-content {
    border: ${themeVariables["popover-border-width"]} solid ${themeVariables["popover-border"]};
    border-radius: ${themeVariables["border-radius-medium"]};
    box-shadow: none !important;
  }

  .modal.dx-popup-wrapper > .dx-overlay-content,
  .modal.dx-popup-wrapper > .dx-overlay-content {
    border-radius: ${themeVariables["modal-border-radius"]};
    border: none;
  }

  .dx-popup-wrapper.header-outside-of-modal > .dx-overlay-content {
    overflow: visible;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
    > .dx-popup-title {
      padding: 0;
      height: 0;
      min-height: 0;
      position: relative;
      margin-top: -30px;
      display: grid;
      grid-template-columns: 100%;
    }
    > .dx-popup-content {
      overflow: hidden;
    }
  }

  .dx-dropdownlist-popup-wrapper.dx-popup-wrapper > .dx-overlay-content,
  .dx-datebox-wrapper.dx-popup-wrapper > .dx-overlay-content,
  .dx-header-filter-menu.dx-popup-wrapper > .dx-overlay-content,
  .dx-popup-wrapper.popover-as-dropdown > .dx-overlay-content,
  .dx-popover-wrapper > .dx-overlay-content {
    box-shadow: none;
  }
  .popover-as-dropdown .dx-overlay-content > .dx-popup-content,
  .dx-popup-wrapper.dx-dropdowneditor-overlay > .dx-overlay-content,
  .dx-popup-wrapper.dx-selectbox-popup-wrapper > .dx-overlay-content {
    box-shadow: ${themeVariables["popover-box-shadow"]};
  }
  .dx-popup-wrapper.popover-as-dropdown {
    > .dx-overlay-content {
      max-width: unset;
      margin-top: 0;
      margin-bottom: 0;
      padding: 0;

      > .dx-popover-arrow {
        display: none;
        width: 0;
        height: 0;
      }
      > .dx-popup-content {
        color: #fff;
        padding: 0;
      }

      .popover-content {
        min-height: ${themeVariables["input-height-base"]};
        padding: 0;
        margin: 0;
      }
    }
  }

  .dx-popup-wrapper.transparent-popover > .dx-overlay-content {
    border: none;
    padding: 0;
    background: transparent;
    .dx-popup-content {
      padding: 0;
    }
  }

  .dx-popup-wrapper.dark-popover:not(.popover-as-dropdown) > .dx-overlay-content {
    border: none !important;
  }

  .dx-popup-wrapper.dark-popover:not(.popover-as-dropdown) > .dx-overlay-content .dx-popup-content {
    padding: 8px 12px;
    border-radius: ${themeVariables["border-radius-medium"]};
  }

  .dx-popup-wrapper.dark-popover > .dx-overlay-content {
    background-color: ${themeVariables["dark-popover-bg"]};
    border-color: ${themeVariables["dark-popover-border"]};
    border-radius: ${themeVariables["border-radius-medium"]};
    opacity: 1 !important;

    .dx-popover-arrow:after {
      background-color: ${themeVariables["dark-popover-bg"]};
      border-color: ${themeVariables["dark-popover-color"]};
    }
    .dx-popup-content {
      color: ${themeVariables["dark-popover-color"]};
      box-shadow: ${themeVariables["dark-popover-box-shadow"]};

      .dx-widget:not(.dx-button) {
        color: ${themeVariables["dark-popover-color"]};
      }

      li.divider {
        height: 1px;
        background-color: ${themeVariables["dropdown-divider-bg"]};
        opacity: 0.3;
      }
      .dropdown-menu-item {
        color: ${themeVariables["dropdown-menu-item-color"]};
        &:active {
          background-color: ${themeVariables["dropdown-link-active-bg"]} !important;
        }

        &:hover,
        &:focus {
          background-color: ${themeVariables["dropdown-link-hover-bg"]};
        }
      }
    }
  }

  .dx-popup-wrapper.p-0 > .dx-overlay-content > .dx-popup-content {
    padding: 0;
  }
  .dx-popup-wrapper.no-border > .dx-overlay-content {
    border: 0;
  }

  .dx-popup-wrapper {
    &.invisible-popover-arrow {
      .dx-popover-arrow {
        visibility: hidden;
        width: 1px;
        height: 1px;
      }
    }
    &.no-popover-arrow {
      .dx-popover-arrow {
        display: none;
        width: 0;
        height: 0;
      }
      .dx-popover-arrow::after {
        width: 0;
        height: 0;
      }
    }
    &.content-pr-0 {
      .dx-overlay-content .dx-popup-content {
        padding-right: 0;
      }
    }
  }

  .dx-popup-wrapper:not(.popover-as-dropdown):not(.dx-header-filter-menu):not(
      .dx-popover-wrapper
    ):not(.dx-datebox-wrapper):not(.dx-filterbuilder-overlay):not(
      .dx-dropdownlist-popup-wrapper
    ):not(.dx-selectbox-popup-wrapper)
    > .dx-overlay-content
    > .dx-popup-content:not(.dx-visibility-change-handler) {
    padding: ${themeVariables["panel-body-padding"]};
  }

  .dx-popover-wrapper .dx-overlay-content .dx-popup-content {
    padding: ${themeVariables["padding-xxxs"]};
    border-radius: ${themeVariables["border-radius-small"]};
  }
  .dx-popover-wrapper.confirmation-dialog > .dx-overlay-content {
    border-radius: ${themeVariables["modal-border-radius"]};
    box-shadow: ${themeVariables["popover-box-shadow"]};
    max-width: ${themeVariables["confirm-panel-max-width"]};
    .dx-popup-content {
      padding: 0;
    }
  }
  .dx-popover-wrapper.confirmation-dialog-as-modal {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 5} !important;
    background-color: ${shadingLightestColor};
    > .dx-overlay-content {
      left: 50vw !important;
      top: 50vh !important;
      transform: translate(-50%, -50%) !important;
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 5} !important;
    }
  }
  .dx-popup-title {
    padding: 12px 16px;
    border-bottom: 0 none;

    &.dx-toolbar {
      padding: 15px 20px 5px;
      .dx-toolbar-label {
        font-size: ${themeVariables["font-size-h5"]};
      }
    }
  }

  .dx-popup-wrapper:not(.dx-header-filter-menu) {
    .dx-toolbar.dx-popup-bottom {
      padding: 0 20px 20px;
    }
  }

  .dx-overlay-content .dx-popup-content {
    overflow: visible;

    & + .dx-popup-bottom {
      padding-top: 0;
    }

    .border-bottom.stretch-to-popup-size {
      margin: ${`0 -${themeVariables.padding}`};
    }
  }

  .dx-popup-wrapper[height="auto"] .dx-overlay-content,
  .dx-popup-wrapper[height="auto"] .dx-overlay-content .dx-popup-content {
    height: auto !important;
  }

  .dx-dropdownlist-popup-wrapper
    .dx-list:not(.dx-list-select-decorator-enabled)
    .dx-list-item-content {
    padding: 6px 12px;
  }

  .dx-dropdownlist-popup-wrapper.dx-popup-wrapper .dx-overlay-content .dx-popup-content {
    padding: 0;
    .dx-list-item {
      min-height: ${themeVariables["dropdown-link-min-height"]};
    }
    .dx-list-item:not(:first-child) {
      margin-top: 0;
    }
  }

  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-devextreme-dx-menu-base"])}"] {
    z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"])} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"])} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 1}"] {
    z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 1} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 1} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 2}"] {
    z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"] + 2)} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 2} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 3}"] {
    z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 3} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 3} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-pageheader-menu"])}"] {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"])} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"])} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-pageheader-menu"]) + 1}"] {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 1} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 1} !important;
    }
  }
  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-pageheader-menu"]) + 2}"] {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 2} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 2} !important;
    }
  }

  .dx-popup-wrapper.dx-overlay-shader:not([id]),
  .dx-popup-wrapper.dx-overlay-shader[id^="${MODAL_ELEMENT_ID_PREFIX}"],
  .dx-popup-wrapper.dx-overlay-shader:not([id]) + .dx-popup-wrapper.dx-overlay-wrapper,
  .dx-popup-wrapper.dx-overlay-shader:not([id])
    + .dx-gesture-cover
    + .dx-popup-wrapper.dx-overlay-wrapper,
  .dx-overlay-wrapper.dx-popup-wrapper.dx-header-filter-menu {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 5} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 5} !important;
    }
  }

  .dx-popup-wrapper[zIndex="${parseInt(themeVariables["zindex-pageheader-menu"]) + 6}"] {
    z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 6} !important;
    > div {
      z-index: ${parseInt(themeVariables["zindex-pageheader-menu"]) + 6} !important;
    }
  }

  .dx-popup-content {
    padding: 10px;
  }
  .dx-popup-bottom.dx-toolbar {
    padding: 10px;
  }
  .dx-popup-bottom.dx-toolbar .dx-toolbar-item {
    padding: 0 20px 0 0;
  }
  .dx-popup-title .dx-closebutton {
    left: 0;
  }

  .dx-popup.dx-widget.dx-visibility-change-handler {
    display: none;
  }
`;
export const dxDataGrid = css `
  .dx-datagrid-content .dx-datagrid-table .dx-group-row {
    > td.dx-datagrid-group-space {
      vertical-align: middle;
      padding: 0 !important;
      &,
      .dx-datagrid-group-opened,
      .dx-datagrid-group-closed {
        &,
        &:before {
          color: inherit !important;
        }
      }
    }
    &:not(.dx-row-focused) {
      color: ${themeVariables["table-row-group-color"]};
      background-color: ${themeVariables["table-row-group-bg"]};
    }
    &.dx-row-focused {
      color: ${themeVariables["table-row-group-focused-color"]};
      background-color: ${themeVariables["table-row-group-focused-bg"]};
    }
  }
  .dx-datagrid .dx-loadpanel-wrapper .dx-loadpanel-message {
    display: none;
  }
  .dx-datagrid .dx-row.dx-header-row {
    background-color: ${themeVariables["table-header-bg-color"]};
    > td {
      padding-top: 0;
      padding-bottom: 0;
    }
    > td.header-row-overflow-visible > .dx-datagrid-text-content {
      overflow: visible;
    }
    > td > .dx-datagrid-text-content {
      white-space: nowrap;
      color: ${themeVariables["table-header-color"]};
      font-weight: ${themeVariables["table-header-font-weight"]};
      font-size: ${themeVariables["table-header-font-size"]};
    }
    > td.normal-wrap > .dx-datagrid-text-content {
      white-space: normal;
    }
  }
  .dx-datagrid .dx-row.dx-datagrid-filter-row > td {
  }

  .dx-datagrid-focus-overlay {
    display: none;
  }

  .dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-popup-content {
    padding: 0 ${parseInt(themeVariables["panel-body-padding"]) / 2}px
      ${parseInt(themeVariables["panel-body-padding"]) / 2}px !important;
  }

  .dx-datagrid-column-chooser.dx-datagrid-column-chooser-mode-select .dx-popup-title {
    padding: 7px 10px 7px 20px;
  }

  .dx-datagrid-rowsview .dx-data-row .dx-cell-modified {
    &.dx-cell-modified:after {
      border-color: transparent;
    }

    .dx-highlight-outline:after {
      border: none;
    }
  }

  .dx-datagrid-rowsview.dx-empty {
    height: 100%;
    min-height: ${SIZES.NO_DATA_MIN_HEIGHT};
  }
  .dx-datagrid-nodata {
    color: ${themeVariables["gray-400"]};
    font-size: 1.2em;
    line-height: 1.4em;
    text-align: center;
    display: grid;
    justify-content: center;
    align-content: center;
    min-height: ${SIZES.NO_DATA_MIN_HEIGHT};
  }

  .dx-datagrid-checkbox-size .dx-checkbox-icon {
    width: ${SIZES.CHECK_BOX_SIZE}px;
    height: ${SIZES.CHECK_BOX_SIZE}px;
    border-radius: 4px;
  }
  .dx-datagrid-checkbox-size .dx-checkbox-icon {
    color: ${themeVariables["gray-700"]} !important;
    border-color: ${themeVariables["gray-400"]} !important;
  }
  .dx-datagrid-checkbox-size.dx-checkbox-checked .dx-checkbox-icon {
    border-color: ${themeVariables["gray-500"]} !important;
    font-size: 10px;
  }

  .dx-datagrid {
    color: ${themeVariables["text-color"]};
    font-size: ${themeVariables["font-size-base"]};
    background: transparent;

    .datagrid-toolbar-search-panel {
      width: ${SIZES.DATA_GRID_SEARCH_PANEL_WIDTH}px;
      .dx-datagrid-search-panel {
        width: 100% !important;
      }
    }

    .dx-datagrid-filter-panel,
    .dx-datagrid-rowsview,
    .dx-datagrid-headers,
    .dx-header-filter-menu {
      background: ${themeVariables["table-bg"]};
    }
  }

  .dx-datagrid .dx-row > td {
    padding: ${`${themeVariables["table-cell-padding-y"]} ${themeVariables["table-cell-padding-x"]}`};
  }
  .dx-datagrid .dx-row.dx-state-hover {
    cursor: pointer;
  }
  .dx-datagrid-table
    .dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(
      .dx-edit-row
    ):not(.dx-row-focused)
    > td:not(.dx-focused) {
    background-color: ${themeVariables["table-bg-hover"]};
    color: ${themeVariables["text-color"]};
  }

  .dx-datagrid .dx-datagrid-header-panel {
    border-bottom: 0;
    .dx-toolbar {
      background: transparent;
      margin-bottom: ${themeVariables["table-toolbar-margin-bottom"]};
      .dx-toolbar-item:first-child {
        padding: 0;
      }
      .dx-toolbar-item:last-child {
        padding: 0 0 0 ${themeVariables["table-toolbar-item-gap"]};
      }
      .dx-toolbar-item {
        padding: 0 ${themeVariables["table-toolbar-item-gap"]} 0 0;
      }
    }
  }
  .dx-datagrid-content .dx-datagrid-table .dx-row .dx-command-select {
    width: 46px;
    min-width: 46px;
    max-width: 46px;
    padding: 0;
  }

  .dx-datagrid .dx-datagrid-headers .dx-header-row td {
    border-bottom: none;
  }
  .dx-datagrid .dx-datagrid-headers .dx-datagrid-filter-row td {
    border-top: 1px solid ${themeVariables["table-border-color"]};
  }

  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover:not(.dx-row-lines) > td,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-lines) > td {
    border-bottom: 0 none;
    border-top: 0 none;
  }
  .dx-datagrid-content .dx-datagrid-table .dx-row > td,
  .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
    vertical-align: middle;
  }
  .dx-datagrid .dx-datagrid-search-panel {
    margin: 0;
  }

  @keyframes cellHighlightAnimation {
    0%,
    50% {
      background-color: ${themeVariables["brand-primary-300"]};
    }
    99% {
      background-color: transparent;
    }
    100% {
    }
  }

  .dx-datagrid-content .dx-datagrid-table .dx-row > td.highlighted-cell {
    animation: cellHighlightAnimation 2s ease-out 0s forwards;
  }

  .dx-datagrid-headers .dx-datagrid-content .dx-datagrid-table .dx-header-row,
  .dx-datagrid-filter-row .dx-menu {
    margin-top: 0;
    margin-left: 0;
  }

  .dx-datagrid .dx-header-filter,
  .dx-datagrid-filter-panel .dx-icon-filter {
    &:before {
      content: "\\e974";
      font: ${themeVariables["icomoon-icons"]};
      font-size: 16px;
    }
  }

  .dx-datagrid .dx-column-indicators {
    display: inline-block;
    vertical-align: bottom;
    white-space: nowrap;
    transform: translateY(1px)
      translateX(${`${parseInt(themeVariables["table-cell-padding-x"]) / 2}px`});
    float: right;
    margin-right: 0;
    > * {
      vertical-align: middle;
    }
  }

  .dx-header-row {
    > td {
      &:not(.dx-command-select) {
        text-align: left !important;
      }
      > .dx-datagrid-text-content {
        vertical-align: middle;
      }
    }
  }

  .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td .dx-header-filter:focus,
  .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus {
    outline: none;
  }

  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-focused,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td.dx-focused,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td.dx-focused,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td.dx-focused,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td,
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td {
    color: ${themeVariables["text-color"]};
    background-color: ${themeVariables["table-bg-active"]};
    &.text-muted {
      color: ${themeVariables["text-muted"]};
    }
  }

  .dx-datagrid-rowsview .dx-row > .dx-master-detail-cell {
    padding: ${themeVariables["panel-body-padding"]};
    color: ${themeVariables["text-color"]};
  }

  .dx-datagrid-content
    .dx-datagrid-table
    .dx-row:not(.dx-datagrid-filter-row)
    td:first-child.dx-editor-cell:not(.dx-command-select) {
    padding-left: ${themeVariables["table-cell-padding-x"]};
  }
  .dx-datagrid-rowsview .dx-texteditor-input {
    padding: 6px;
  }

  .dx-datagrid .dx-column-indicators .dx-header-filter.dx-header-filter:after,
  .dx-datagrid .dx-column-indicators .dx-sort.dx-header-filter:after {
    margin: -9px;
  }

  .dx-datagrid .dx-icon.dx-icon-filter-operation-default,
  .dx-datagrid-container .dx-icon.dx-icon-filter-operation-default {
    &:before {
      color: ${themeVariables["default-icon-color"]} !important;
      content: "\\e978";
      font: ${themeVariables["icomoon-icons"]};
      font-size: 16px;
    }
  }
  .dx-datagrid .dx-icon.dx-icon-filter-operation-default,
  .dx-datagrid-container .dx-icon.dx-icon-filter-operation-default {
    width: 34px;
    height: 18px !important;
  }

  .dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-placeholder:before,
  .dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor-input {
    padding-left: 42px;
    text-align: left !important;
  }
  .dx-datagrid-headers {
    color: ${themeVariables["gray-500"]};
    font-weight: 400;
    border-bottom: 0 none;
  }
  .dx-datagrid-headers .dx-datagrid-content {
    margin-bottom: 0;
  }
  .dx-datagrid .dx-row-lines > td,
  .dx-datagrid-headers .dx-datagrid-table .dx-row > td,
  .dx-datagrid-borders .dx-datagrid-rowsview,
  .dx-datagrid-headers + .dx-datagrid-rowsview,
  .dx-datagrid-borders > .dx-datagrid-headers,
  .dx-datagrid-borders > .dx-datagrid-filter-panel {
    border-color: ${themeVariables["table-border-color"]};
  }
  .dx-datagrid-headers .dx-datagrid-table .dx-row.dx-datagrid-filter-row > td {
    border-bottom: 0 none;
  }
  .dx-datagrid-headers > :not(:last-child) {
    display: none;
  }

  .dx-datagrid .dx-datagrid-rowsview .dx-row.dx-freespace-row > td {
    border-color: transparent;
  }
  .dx-header-row .dx-header-filter-indicator,
  .dx-header-row .dx-sort-indicator {
    max-width: calc(100% - 26px + ${`${parseInt(themeVariables["table-cell-padding-x"]) / 2}px`});
  }
  .dx-header-row .dx-sort-indicator.dx-header-filter-indicator {
    max-width: calc(100% - 38px + ${`${parseInt(themeVariables["table-cell-padding-x"]) / 2}px`});
  }

  .dx-datagrid-filter-panel .dx-datagrid-filter-panel-clear-filter,
  .dx-datagrid-filter-panel .dx-datagrid-filter-panel-text {
    color: ${themeVariables["gray-500"]};
    &:hover,
    &:focus,
    &:focus:active {
      color: ${themeVariables["gray-600"]};
    }
  }

  .dx-datagrid-filter-panel .dx-icon-filter,
  .dx-datagrid .dx-header-filter.dx-header-filter-empty {
    color: ${themeVariables["default-icon-color"]};
  }

  .dx-datagrid .dx-header-filter,
  .dx-datagrid .dx-sort {
    color: ${themeVariables["gray-500"]};
    width: ${themeVariables["table-cell-padding-x"]};
    &:before {
      width: ${themeVariables["table-cell-padding-x"]};
    }
  }
  .dx-datagrid .dx-column-indicators.dx-visibility-hidden {
    display: none;
  }

  .dx-editor-with-menu
    .dx-filter-menu
    .dx-menu-item-content
    .dx-icon.dx-icon-filter-operation-default,
  .dx-filter-menu .dx-menu-item-content .dx-icon.dx-icon-filter-operation-default {
    margin-top: 0;
  }

  .dx-datagrid-column-chooser-list.dx-treeview .dx-empty-message,
  .dx-device-mobile .dx-datagrid-column-chooser-list.dx-treeview .dx-empty-message {
    transform: translateY(50%);
  }

  .dx-datagrid-rowsview .dx-overlay-wrapper.dx-invalid-message > .dx-overlay-content {
    background-color: ${themeVariables["brand-danger-200"]};
    border: 1px solid ${themeVariables["brand-danger-400"]};
    color: ${themeVariables["brand-danger-400"]};
    border-radius: ${themeVariables["border-radius-small"]};
    font-size: ${themeVariables["font-size-small"]};
    padding: 0.3em 0.75em;
    line-height: 1.5;
    opacity: 0.9;
    &:hover {
      opacity: 1;
    }
  }

  .dx-overlay-content.dx-inner-overlay.dx-datagrid.dx-filter-menu.dx-menu-base {
    background-color: transparent;
    .dx-context-menu-content-delimiter {
      height: 7px !important;
      margin-top: -3px !important;
    }
  }

  .dx-datagrid-filter-panel-left {
    align-items: center;
  }

  .dx-datagrid-search-text {
    position: relative;
    background: transparent;
    color: inherit;
    &:before {
      position: absolute;
      top: -2px;
      left: -1px;
      content: " ";
      display: inline-block;
      background: ${themeVariables["brand-warning-300"]};
      opacity: 0.5;
      border-radius: ${themeVariables["border-radius-small"]};
      transform: skew(-12deg);
      height: calc(100% + 4px);
      width: calc(100% + 2px);
    }
  }
  .dx-filterbuilder {
    padding: 0 ${themeVariables["panel-body-padding"]};
  }
  .dx-filterbuilder-overlay .dx-overlay-content.dx-popup-normal > .dx-popup-content {
    max-width: 450px;
  }
`;
export const dxResizable = css `
  .custom-top-resizable .dx-resizable-handle-top,
  .custom-bottom-resizable .dx-resizable-handle-bottom,
  .custom-left-resizable .dx-resizable-handle-left {
    background-color: transparent;
    border: 1px solid ${themeVariables["gray-100"]};
    text-align: center;

    // &::after {
    //   content: '\\e938';
    //   font: ${themeVariables["icomoon-icons"]};
    //   color: ${themeVariables["gray-400"]};
    //   font-size: ${SIZES.RESIZABLE_HANDLER_ICON_SIZE}px !important;
    //   position: absolute;
    //   height: ${SIZES.RESIZABLE_HANDLER_ICON_SIZE}px;
    //   width: ${SIZES.RESIZABLE_HANDLER_ICON_SIZE}px;
    // }
  }

  .dx-resizable-handle {
    border: none !important;
  }
  .custom-top-resizable {
    transform: unset !important;
    box-sizing: border-box;
    .dx-resizable-handle-top {
      height: ${SIZES.RESIZABLE_HANDLER_SIZE}px;
      top: 0;
    }
  }
  .custom-bottom-resizable {
    box-sizing: border-box;
    .dx-resizable-handle-bottom {
      height: ${SIZES.RESIZABLE_HANDLER_SIZE}px;
      bottom: 0;
    }
  }
  .custom-left-resizable {
    transform: unset !important;
    box-sizing: border-box;
    .dx-resizable-handle-left {
      width: ${SIZES.RESIZABLE_HANDLER_SIZE}px;
      left: 0;

      &::after {
        top: 50%;
        left: 0;
        transform: rotate(90deg);
      }
    }
  }
`;
export const dxScrollable = css `
  .dx-scrollview-scrollbottom .dx-scrollview-scrollbottom-text {
    display: none;
  }
  .dx-scrollview-scrollbottom-indicator {
    margin: 0;
    line-height: 1;
    > .dx-loadindicator {
      width: ${SIZES.LOAD_INDICATOR_SIZE}px;
      height: ${SIZES.LOAD_INDICATOR_SIZE}px;
    }
  }

  .dx-loadindicator-content .dx-loadindicator-icon {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    > * {
      display: none;
      &.dx-loadindicator-segment0,
      &.dx-loadindicator-segment1,
      &.dx-loadindicator-segment2 {
        background: ${themeVariables["loader-bg"]};
        display: block;
        border-radius: 50%;
        left: calc(50% - ${SIZES.LOAD_INDICATOR_SIZE / 10}px);
        width: ${SIZES.LOAD_INDICATOR_SIZE / 5}px;
        height: ${SIZES.LOAD_INDICATOR_SIZE / 5}px;
      }
      &.dx-loadindicator-segment0 {
        transform: translate(-150%, 0);
      }
      &.dx-loadindicator-segment1 {
        transform: translate(0, 0);
      }
      &.dx-loadindicator-segment2 {
        transform: translate(150%, 0);
      }
    }
  }

  .custom-scrollable {
    display: grid;
    grid-auto-rows: 1fr;

    > .dx-scrollview-loadpanel {
      display: none;
    }

    > .dx-scrollable-wrapper {
      overflow: hidden;

      > .dx-scrollable-container > .dx-scrollable-content {
        .dx-scrollview-top-pocket,
        .dx-scrollview-bottom-pocket {
          display: none;
        }

        display: grid;
        align-items: stretch;
        justify-items: stretch;

        .dx-scrollview-content {
          overflow: hidden;
        }

        &:after,
        &:before {
          display: none;
        }
      }
    }
  }

  .scrollable-wrapper,
  .scrollable-wrapper-extra-right-space {
    height: 100%;
    overflow: hidden;
  }
  .scrollable-wrapper {
    width: 100%;
  }
  .scrollable-wrapper-extra-right-space {
    width: calc(100% + ${SIZES.SCROLL_EXTRA_SPACE});

    .dx-scrollable .dx-scrollable-wrapper .dx-scrollable-content {
      width: calc(100% - ${SIZES.SCROLL_EXTRA_SPACE});
    }
  }

  .dx-scrollbar-vertical.dx-scrollbar-hoverable {
    user-select: none;
    border-radius: 7px;
  }
  .dx-scrollable-scroll-content {
    border-radius: ${themeVariables["border-radius-base"]};
    background-color: ${themeVariables["scroll-color"]};
  }
  .dx-scrollable-scrollbar {
    background-color: ${themeVariables["scroll-bg"]};
  }

  .dx-scrollable-scrollbars-alwaysvisible.dx-scrollable-vertical
    > .dx-scrollable-wrapper
    > .dx-scrollable-container
    > .dx-scrollable-content {
    padding-right: 0;
  }
`;
export const rcVirtualList = css `
  body {
    .rc-virtual-list > .rc-virtual-list-scrollbar {
      width: auto !important;
      background-color: ${chroma(themeVariables["gray-300"]).alpha(0.25).css()} !important;
      border-radius: ${SIZES.VIRTUAL_SCROLL_BAR_WIDTH / 2}px;
      right: ${SIZES.VIRTUAL_SCROLL_BAR_RIGHT_SPACE}px !important;

      .rc-virtual-list-scrollbar-thumb {
        position: relative !important;
        transition: width 0.25s linear 0.15s;
        width: 0 !important;
        background-color: ${chroma(themeVariables["gray-300"]).alpha(0.65).css()} !important;
      }
    }
    .rc-virtual-list:hover > .rc-virtual-list-scrollbar {
      visibility: visible !important;
    }
    .rc-virtual-list:hover > .rc-virtual-list-scrollbar > .rc-virtual-list-scrollbar-thumb {
      width: ${SIZES.VIRTUAL_SCROLL_BAR_WIDTH / 2 + 1}px !important;
    }
    .rc-virtual-list > .rc-virtual-list-scrollbar:hover > .rc-virtual-list-scrollbar-thumb,
    .rc-virtual-list
      > .rc-virtual-list-scrollbar
      > .rc-virtual-list-scrollbar-thumb.rc-virtual-list-scrollbar-thumb-moving {
      width: ${SIZES.VIRTUAL_SCROLL_BAR_WIDTH}px !important;
    }
  }

  .dx-drawer-wrapper .dx-drawer-content,
  .popover-as-dropdown {
    .rc-virtual-list > .rc-virtual-list-scrollbar {
      background-color: ${themeVariables["scroll-color"]} !important;

      .rc-virtual-list-scrollbar-thumb {
        background-color: ${themeVariables["scroll-bg"]} !important;
      }
    }
  }
`;
export const dxRichEditor = css `
  .dxreControl {
    border-width: 0px;
    font-family: ${themeVariables["font-family-base"]};
    font-size: ${themeVariables["font-size-small"]};
    color: ${themeVariables["text-color"]};
    font-weight: 400;
    line-height: ${themeVariables["line-height-medium"]};
    z-index: ${parseInt(themeVariables["zindex-navbar-fixed"]) + 2} !important;

    .dxreHeaderInfo,
    .dxreFooterInfo {
      b {
        color: ${themeVariables["rich-editor-heder-and-footer-b-color"]};
        background-color: ${themeVariables["rich-editor-heder-and-footer-b-bg"]};
      }
    }
    .dxreHeaderInfo {
      border-top: ${themeVariables["rich-editor-heder-and-footer-border"]};
    }
    .dxreFooterInfo {
      border-bottom: ${themeVariables["rich-editor-heder-and-footer-border"]};
    }

    .dxreRulerWrapper {
      /* Линейка */
      .dxreRuler {
        /* Правый и левый отступ */
        .dxre-rulerMarginRightPanel,
        .dxre-rulerMarginLeftHandlePanel,
        .dxre-rulerMarginRightHandlePanel,
        .dxre-rulerMarginLeftPanel,
        .dxre-rulerMarginRightPanel,
        .dxre-rulerMarginLeftHandlePanel,
        .dxre-rulerMarginRightHandlePanel,
        .dxre-columnHandle {
          background-color: ${themeVariables["rich-editor-line-bg"]};
        }
      }
    }

    .dx-toolbar-button .dx-button {
      padding: ${themeVariables["padding-xxxs"]} 0.5em;
      height: auto;
      .dx-button-content {
        font-size: ${themeVariables["font-size-small"]};
      }
    }
    .dx-texteditor-input:not(textarea) {
      height: auto;
      padding-top: ${themeVariables["padding-xxxs"]};
      padding-bottom: ${themeVariables["padding-xxxs"]};
    }

    .dx-r-separator-container {
      height: 2.2em;
    }
    .dx-toolbar .dx-toolbar-items-container {
      height: 30px;
    }
    .dx-toolbar-button .dx-button .dx-icon,
    .dx-menu-base .dx-icon {
      &:before {
        font-size: 16px !important;
        color: ${themeVariables["btn-default-color"]};
      }
    }

    .dx-menu-base .dx-menu-item .dx-menu-item-content .dx-menu-item-popout-container {
      right: 1px;
      top: 1px;
    }

    .dx-menu-item-content .dx-icon {
      height: 16px !important;
    }
    .dx-toolbar-button .dx-button .dx-icon {
      height: 14px !important;
    }

    .dx-menu.dx-ribbon-item .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
      margin-right: 6px;
    }
    .dx-menu .dx-menu-item-has-text.dx-menu-item-has-submenu .dx-menu-item-text {
      padding: 1px 18px 1px 1px;
    }
    .dx-toolbar-button .dx-menu .dx-menu-item .dx-menu-item-content {
      padding-top: 3px;
      padding-bottom: 4px;
      border-radius: ${themeVariables["border-radius-base"]};
    }
    .dx-context-menu-container-border {
      border-radius: ${themeVariables["border-radius-base"]};
      border-width: 0;
    }
    .dx-menu-item {
      border: 1px solid transparent;
    }
    .dx-menu-item.dx-state-hover,
    .dx-menu-item.dx-state-focused,
    .dx-menu-item.dx-menu-item-expanded {
      color: ${themeVariables["btn-default-color-hover"]};
      border-color: ${themeVariables["btn-default-border-hover"]};
      background-color: ${themeVariables["btn-default-bg-hover"]};
      .dx-icon:before {
        color: ${themeVariables["btn-default-color-hover"]};
      }
    }
    .dx-dropdowneditor-button {
      width: 28px;
      min-width: 28px;
    }
    .dx-selectbox.dx-dropdowneditor-button-visible.dx-state-active,
    .dx-selectbox.dx-dropdowneditor-button-visible.dx-state-hover {
      background-color: ${themeVariables["btn-default-bg-hover"]};
      border-color: ${themeVariables["btn-default-border-hover"]};
    }

    .dx-dropdowneditor-icon {
      width: 25px;
      border-radius: ${themeVariables["border-radius-base"]};
      transform: none !important;
      background-color: transparent !important;
      &:before {
        margin-top: -8px;
        margin-left: -8px;
      }
    }

    .dx-tabpanel.dx-ribbon {
      /* Панель вкладок*/
      > .dx-tabpanel-tabs {
        /* панель вкладок*/
        .dx-tabs {
          /* Вкладки */
          border: ${themeVariables["rich-editor-tab-panel-border"]};
          border-top: 0;
          box-shadow: ${themeVariables["rich-editor-tab-panel-shadow"]};
          background-color: ${themeVariables["rich-editor-tab-panel-bg"]};
          display: table;
          .dx-tabs-wrapper {
            display: flex !important;
            gap: ${themeVariables["rich-editor-tab-panel-gap"]};
            overflow: hidden;
            .dx-tab {
              flex: 1;
              min-width: 200px;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: ${themeVariables["rich-editor-tab-border-radius"]};
              height: ${themeVariables["rich-editor-tab-height"]};
              box-shadow: ${themeVariables["rich-editor-tab-shadow"]};
              border-right: ${themeVariables["rich-editor-tab-border"]};
              padding: ${themeVariables["rich-editor-tab-padding"]};
              color: ${themeVariables["rich-editor-tab-color"]};
              background-color: ${themeVariables["rich-editor-tab-bg"]};
              font-family: var(--font-regular);
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              letter-spacing: 0.25px;
              &:hover {
                color: ${themeVariables["rich-editor-tab-color-hover"]};
                background-color: ${themeVariables["rich-editor-tab-bg-hover"]};
              }
              &.dx-tab-selected {
                color: ${themeVariables["rich-editor-tab-color-selected"]};
                background-color: ${themeVariables["rich-editor-tab-bg-selected"]};
              }
              &.dx-tab-selected:after {
                position: absolute;
                bottom: -1px;
                left: 0;
                right: 0;
                content: "";
                display: block;
                height: 1px;
                background-color: ${themeVariables["rich-editor-tab-sleeted-bottom-line-bg"]};
              }
            }
          }
        }
      }

      > .dx-tabpanel-container {
        .dx-editor-filled {
          height: ${themeVariables["rich-editor-text-editor-height"]};
          border: ${themeVariables["rich-editor-text-editor-border"]};
          color: ${themeVariables["rich-editor-text-editor-color"]} !important;
          background-color: ${themeVariables["rich-editor-text-editor-bg"]} !important;
          border-radius: ${themeVariables["rich-editor-text-editor-border-radius"]};

          .dx-placeholder {
            color: ${themeVariables["rich-editor-text-editor-placeholder-color"]} !important;
          }

          .dx-icon::before {
            color: ${themeVariables["rich-editor-text-editor-icon-color"]} !important;
          }

          .dx-texteditor-input-container {
            align-items: center;
          }
          .dx-numberbox-spin-button {
            .dx-numberbox-spin-up-icon,
            .dx-numberbox-spin-down-icon {
              background-color: transparent !important;
              &::before {
                color: ${themeVariables["rich-editor-menu-arrow-icon-color"]};
              }
            }

            &.dx-state-hover {
              .dx-numberbox-spin-up-icon,
              .dx-numberbox-spin-down-icon {
                &::before {
                  color: ${themeVariables["rich-editor-menu-arrow-icon-color-hover"]};
                }
              }
            }

            &.dx-state-active,
            &.dx-state-focused {
              .dx-numberbox-spin-up-icon,
              .dx-numberbox-spin-down-icon {
                &::before {
                  color: ${themeVariables["rich-editor-menu-arrow-icon-color-active"]};
                }
              }
            }
          }

          &.dx-state-active,
          &.dx-state-focused,
          &.active {
            border-color: ${themeVariables["rich-editor-text-editor-border-focus"]} !important;
            border-width: 2px !important;
            background: ${themeVariables["rich-editor-text-editor-bg-active"]} !important;
          }

          &.dx-state-hover:not(.dx-state-focused):not(.dx-state-active):not(.error):not(.active) {
            border: ${themeVariables["rich-editor-text-editor-border"]};
            background: ${themeVariables["rich-editor-text-editor-bg-hover"]} !important;
            cursor: pointer !important;
          }
        }
        .dx-menu {
          &:not(.dx-showTextInMenu) {
            .dx-menu-item-content {
              .dx-menu-item-popout-container {
                position: unset !important;
                height: unset !important;
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .dx-menu-item-popout {
                  margin: 0;
                  &::before {
                    margin: 0;
                    position: unset !important;
                    color: ${themeVariables["rich-editor-menu-arrow-icon-color"]};
                  }
                }
              }
            }
          }
          .dx-menu-item-content {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .dx-button,
        .dx-menu-item {
          height: ${themeVariables["rich-editor-toolbar-btn-height"]};
          box-shadow: ${themeVariables["rich-editor-toolbar-btn-shadow"]};
          color: ${themeVariables["rich-editor-toolbar-btn-color"]};
          background-color: ${themeVariables["rich-editor-toolbar-btn-bg"]};
          border: ${themeVariables["rich-editor-toolbar-btn-border"]};
          .dx-icon::before {
            color: ${themeVariables["rich-editor-toolbar-btn-icon-color"]};
          }
          &.dx-state-hover {
            box-shadow: ${themeVariables["rich-editor-toolbar-btn-shadow-hover"]};
            color: ${themeVariables["rich-editor-toolbar-btn-color-hover"]};
            background-color: ${themeVariables["rich-editor-toolbar-btn-bg-hover"]};
            border-color: ${themeVariables["rich-editor-toolbar-btn-border-hover"]};
            .dx-icon::before {
              color: ${themeVariables["rich-editor-toolbar-btn-icon-color-hover"]};
            }
          }
          &.dx-item-selected,
          &.dx-state-active,
          &.dx-menu-item-expanded {
            box-shadow: ${themeVariables["rich-editor-toolbar-btn-shadow-active"]};
            color: ${themeVariables["rich-editor-toolbar-btn-color-active"]};
            background-color: ${themeVariables["rich-editor-toolbar-btn-bg-active"]};
            border-color: ${themeVariables["rich-editor-toolbar-btn-border-active"]};
            .dx-icon::before {
              color: ${themeVariables["rich-editor-toolbar-btn-icon-color-active"]};
            }
          }
          &.dx-state-disabled {
            box-shadow: ${themeVariables["rich-editor-toolbar-btn-shadow-disabled"]};
            color: ${themeVariables["rich-editor-toolbar-btn-color-disabled"]};
            background-color: ${themeVariables["rich-editor-toolbar-btn-bg-disabled"]};
            border-color: ${themeVariables["rich-editor-toolbar-btn-border-disabled"]};
            .dx-icon::before {
              color: ${themeVariables["rich-editor-toolbar-btn-icon-color-disabled"]};
            }
          }
        }
      }
    }
  }

  .dx-toolbar-menu-section.dx-toolbar-menu-last-section {
    .dx-editor-filled {
      border: none !important;
      color: ${themeVariables["dropdown-link-color"]} !important;
      background-color: ${themeVariables["dropdown-link-bg"]} !important;
      border-radius: 0 !important;

      .dx-placeholder {
        color: ${themeVariables["dropdown-link-color"]} !important;
      }

      .dx-icon::before {
        color: ${themeVariables["rich-editor-text-editor-icon-color"]} !important;
      }

      .dx-texteditor-input-container {
        align-items: center;
      }

      .dx-dropdowneditor-icon {
        background-color: ${themeVariables["dropdown-link-btn-bg"]} !important;

        &::before {
          color: ${themeVariables["dropdown-link-btn-color"]} !important;
        }
      }

      .dx-numberbox-spin-button {
        .dx-numberbox-spin-up-icon,
        .dx-numberbox-spin-down-icon {
          background-color: transparent !important;
          &::before {
            color: ${themeVariables["rich-editor-menu-arrow-icon-color"]};
          }
        }

        &.dx-state-hover {
          .dx-numberbox-spin-up-icon,
          .dx-numberbox-spin-down-icon {
            &::before {
              color: ${themeVariables["rich-editor-menu-arrow-icon-color-hover"]};
            }
          }
        }

        &.dx-state-active,
        &.dx-state-focused {
          .dx-numberbox-spin-up-icon,
          .dx-numberbox-spin-down-icon {
            &::before {
              color: ${themeVariables["rich-editor-menu-arrow-icon-color-active"]};
            }
          }
        }
      }

      &.dx-state-active,
      &.dx-state-focused,
      &.active {
        color: ${themeVariables["dropdown-link-active-color"]} !important;
        background-color: ${themeVariables["dropdown-link-active-bg"]} !important;
        .dx-dropdowneditor-icon {
          background-color: ${themeVariables["dropdown-link-btn-bg-actve"]} !important;

          &::before {
            color: ${themeVariables["dropdown-link-btn-color-active"]} !important;
          }
        }
      }

      &.dx-state-disabled {
        color: ${themeVariables["dropdown-link-disabled-color"]} !important;
        background-color: ${themeVariables["dropdown-link-disabled-bg"]} !important;
        .dx-dropdowneditor-icon {
          background-color: ${themeVariables["dropdown-link-btn-bg-disabled"]} !important;

          &::before {
            color: ${themeVariables["dropdown-link-btn-color-disabled"]} !important;
          }
        }
      }

      &.dx-state-hover:not(.dx-state-focused):not(.dx-state-active):not(.error):not(.active) {
        color: ${themeVariables["dropdown-link-hover-color"]} !important;
        background-color: ${themeVariables["dropdown-link-hover-bg"]} !important;
        cursor: pointer !important;

        .dx-dropdowneditor-icon {
          background-color: ${themeVariables["dropdown-link-btn-bg-hover"]} !important;

          &::before {
            color: ${themeVariables["dropdown-link-btn-color-hover"]} !important;
          }
        }
      }
    }

    .dx-button,
    .dx-menu-item {
      box-shadow: none !important;
      color: ${themeVariables["dropdown-link-color"]} !important;
      background-color: ${themeVariables["dropdown-link-bg"]} !important;
      border: none !important;

      .dx-icon::before {
        color: ${themeVariables["dropdown-link-color"]} !important;
      }
      &.dx-state-hover {
        color: ${themeVariables["dropdown-link-hover-color"]} !important;
        background-color: ${themeVariables["dropdown-link-hover-bg"]} !important;
        .dx-icon::before {
          color: ${themeVariables["dropdown-link-hover-color"]} !important;
        }
      }
      &.dx-item-selected,
      &.dx-state-active,
      &.dx-menu-item-expanded {
        color: ${themeVariables["dropdown-link-active-color"]} !important;
        background-color: ${themeVariables["dropdown-link-active-bg"]} !important;
        .dx-icon::before {
          color: ${themeVariables["dropdown-link-active-color"]} !important;
        }
      }
      &.dx-state-disabled {
        color: ${themeVariables["dropdown-link-disabled-color"]} !important;
        background-color: ${themeVariables["dropdown-link-disabled-bg"]} !important;
        .dx-icon::before {
          color: ${themeVariables["dropdown-link-disabled-color"]} !important;
        }
      }
    }
  }

  .dxre-icon-Undo:before {
    font-size: 16px !important;
  }
  .dxre-icon-Redo:before {
    font-size: 16px !important;
  }

  .dx-menu.dx-ribbon-item .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon .dx-icon {
    margin-left: 0 !important;
  }

  .dx-toolbar-menu-custom
    .dx-menu.dx-ribbon-item
    .dx-menu-item.dx-menu-item-has-text.dx-menu-item-has-icon
    .dx-icon {
    margin-right: 2px;
  }

  .dxrePopupTarget ~ .dx-popup-wrapper .dx-overlay-content:not(.dx-menu-base) {
    max-width: 600px !important;
  }
`;
export const dxCalendar = css `
  .dx-editor-cell {
    .dx-datebox-calendar {
      .dx-texteditor-buttons-container {
        margin: 0;
        .dx-dropdowneditor-button {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 28px;
          width: 28px;
          min-height: 28px;
          min-width: 28px;
          .dx-icon,
          .dx-dropdowneditor-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            &:before {
              position: unset !important;
              margin: 0 !important;
              font-size: 12px !important;
            }
          }
        }
      }
    }
  }
  .dx-datebox-calendar {
    .dx-texteditor-buttons-container {
      width: 28px;
      height: 28px;
      margin-top: 8px;
      margin-right: 8px;
      margin-bottom: 8px;

      .dx-dropdowneditor-button {
        background-color: ${themeVariables["editor-menu-btn-bg"]} !important;
        .dx-dropdowneditor-icon:before {
          color: ${themeVariables["editor-menu-btn-color"]} !important;
        }
        border-radius: ${themeVariables["editor-menu-btn-radius"]} !important;
        &.dx-state-hove &:hover {
          background-color: ${themeVariables["editor-menu-btn-hover-bg"]} !important;
          .dx-dropdowneditor-icon:before {
            color: ${themeVariables["editor-menu-btn-hover-color"]} !important;
          }
        }
        &.dx-button.dx-state-active,
        &.dx-button.dx-state-focused,
        &:active {
          background-color: ${themeVariables["editor-menu-btn-active-bg"]} !important;
          .dx-dropdowneditor-icon:before {
            color: ${themeVariables["editor-menu-btn-active-color"]} !important;
          }
        }
      }
    }

    &:has(.dx-popup:not(.dx-state-invisible)) {
      .dx-dropdowneditor-button {
        background-color: ${themeVariables["editor-menu-btn-active-bg"]} !important;
        .dx-dropdowneditor-icon:before {
          color: ${themeVariables["editor-menu-btn-active-color"]} !important;
        }
      }
    }
  }
  .dx-calendar-navigator .dx-button,
  .dx-calendar-navigator .dx-button.dx-state-hover:not(.dx-calendar-disabled-navigator-link),
  .dx-calendar-navigator .dx-button.dx-state-active:not(.dx-calendar-disabled-navigator-link),
  .dx-calendar-navigator .dx-button.dx-state-focused:not(.dx-calendar-disabled-navigator-link) {
    border-color: transparent !important;
  }
  .dx-datebox-wrapper-calendar.dx-datebox-wrapper-datetime .dx-timeview {
    padding: 0;
  }
  .dx-datebox-wrapper-calendar.dx-datebox-wrapper-datetime
    .dx-datebox-datetime-time-side
    .dx-timeview {
    padding: 1em;
  }
  .dx-datebox-wrapper-calendar.dx-datebox-wrapper-datetime .dx-calendar {
    margin-bottom: 0.5em;
  }
  .dx-popup-wrapper.dx-datebox-wrapper .dx-overlay-content .dx-popup-content {
    padding: 0.5em;
  }
  .dx-calendar-cell {
    font-size: ${themeVariables["calendar-cell-font-size"]};
    border-radius: ${themeVariables["calendar-cell-radius"]};
    padding: 0;
    background-color: transparent !important;
    position: relative;
    box-shadow: none !important;
    width: 34px;

    > * {
      display: grid;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      border-radius: ${themeVariables["border-radius-base"]};
      color: ${themeVariables["calendar-cell-in-range-color"]};
      align-content: center;
      justify-content: center;
      font-weight: 400;
    }
    &.dx-calendar-selected-date > * {
      font-weight: 400;
    }
    &.dx-calendar-other-view:not(.dx-calendar-selected-date) > * {
      background-color: ${themeVariables["calendar-cell-out-of-range-bg"]};
      color: ${themeVariables["calendar-cell-out-of-range-color"]};
    }
    &.dx-state-hover:not(.dx-calendar-empty-cell):not(.dx-calendar-selected-date) {
      > * {
        background-color: ${themeVariables["calendar-cell-hover-bg"]};
        color: ${themeVariables["calendar-cell-hover-color"]};
      }
    }
    &.dx-state-active:not(.dx-calendar-empty-cell):not(.dx-calendar-selected-date) {
      > * {
        background-color: ${themeVariables["calendar-cell-active-bg"]};
        color: ${themeVariables["calendar-cell-active-color"]};
      }
    }
  }
  .dx-calendar-view-month .dx-calendar-cell {
    border-radius: 50%;
    > * {
      border-radius: 50%;
      height: 30px;
      width: 30px;
      margin: auto;
      box-shadow: none !important;
      border: none !important;
    }
    &.dx-calendar-selected-date,
    &.dx-calendar-selected-date.dx-state-hover,
    &.dx-calendar-selected-date.dx-state-active {
      > * {
        background-color: ${themeVariables["calendar-cell-selected-bg"]};
        color: ${themeVariables["calendar-cell-selected-color"]};
      }
    }
    &.dx-state-hover:not(.dx-calendar-empty-cell):not(.dx-calendar-selected-date) {
      > * {
        background-color: ${themeVariables["calendar-cell-hover-bg"]};
        color: ${themeVariables["calendar-cell-hover-color"]};
      }
    }
    &.dx-state-active:not(.dx-calendar-empty-cell):not(.dx-calendar-selected-date) {
      > * {
        background-color: ${themeVariables["calendar-cell-active-bg"]};
        color: ${themeVariables["calendar-cell-active-color"]};
      }
    }
  }
  .dx-calendar-cell.dx-calendar-today span {
    border: none;
  }
  .dx-calendar-cell.dx-calendar-contoured-date:not(.dx-calendar-empty-cell):not(
      .dx-calendar-selected-date
    ) {
    > * {
      font-weight: 400;
      border: ${themeVariables["calendar-cell-contoured-border"]};
      background-color: ${themeVariables["calendar-cell-contoured-bg"]};
      color: ${themeVariables["calendar-cell-contoured-color"]};
      box-shadow: none !important;
    }
  }
  .dx-calendar-view-month
    .dx-calendar-cell.dx-calendar-contoured-date:not(.dx-calendar-empty-cell):not(
      .dx-calendar-selected-date
    ) {
    > * {
      font-weight: 400;
      border: none;
    }
  }

  .dx-calendar-view-month
    .dx-calendar-cell.dx-calendar-contoured-date:not(.dx-calendar-empty-cell) {
    box-shadow: none;
    font-weight: 400;
  }
  .dx-calendar-cell.dx-calendar-today {
    font-weight: 500;
  }
  .dx-calendar-body {
    overflow-y: visible;
    padding-bottom: 4px;
  }

  .dx-calendar-navigator {
    .dx-calendar-caption-button {
      font-size: ${themeVariables["calendar-btn-caption-size"]};
    }

    .dx-calendar-navigator-next-view,
    .dx-calendar-navigator-previous-view {
      .dx-button-content {
        color: inherit !important;
        font-weight: 400;
        font-size: ${themeVariables["calendar-btn-view-size"]};

        > .dx-icon {
          font-size: ${themeVariables["calendar-btn-view-size"]};
        }
      }
    }

    .dx-calendar-caption-button,
    .dx-calendar-navigator-next-view,
    .dx-calendar-navigator-previous-view {
      box-shadow: none !important;
      padding: 0;
      border-radius: ${themeVariables["border-radius-base"]};
      .dx-button-content {
        font-weight: 400;
      }
    }
  }

  .dx-calendar-body thead tr th {
    box-shadow: none;
    background-color: ${themeVariables["calendar-cell-day-of-week-bg"]};
    color: ${themeVariables["calendar-cell-day-of-week-color"]};
    font-size: ${themeVariables["calendar-cell-day-of-week-font-size"]};
    text-transform: capitalize;
    font-weight: 400;
  }
  .dx-timeview-field .dx-numberbox {
    width: 75px;
    .dx-texteditor-input {
      padding-right: 2px;
    }
  }
  .dx-datebox-datetime-time-side {
    background-color: transparent;
  }
  .dx-datebox-wrapper-calendar .dx-popup-bottom.dx-popup-cancel.dx-popup-done {
    padding: 8px 12px 12px 12px;
    .dx-toolbar-items-container {
      height: ${themeVariables["input-height-medium"]};
      .dx-toolbar-before {
        display: none;
      }
      .dx-toolbar-after {
        position: static;
        margin: auto;
        padding: 0;
        .dx-toolbar-item {
          padding: 0;
          .dx-button {
            height: ${themeVariables["input-height-medium"]};
          }
        }
      }
    }
  }
  .dx-timeview-clock {
    margin-bottom: 1em;
  }
  .dx-calendar {
    width: 275px;
    min-width: 275px;
    height: 245px;
    min-height: 245px;
    gap: 4px;
  }
`;
export const dxEditor = css `
  .dx-textarea:not(.dx-state-active):not(.dx-state-focused):not(.active).dx-texteditor-empty {
    .dx-texteditor-label .dx-label {
      padding: 5px 2px !important;
    }
  }

  .dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor::after {
    border-radius: ${themeVariables["input-border-radius"]};
    border: 1px solid ${themeVariables["input-border"]} !important;
  }
  .dx-texteditor {
    input {
      border-radius: ${themeVariables["input-border-radius"]};
    }
    .dx-placeholder {
      color: ${themeVariables["input-color-placeholder"]};
    }

    &.dx-editor-outlined {
      &:not(.error) {
        border-color: ${themeVariables["input-border"]};

        .dx-label,
        .dx-label-after,
        .dx-label-before {
          border-color: ${themeVariables["input-border"]} !important;
          color: ${themeVariables["input-color-label"]} !important;
        }
      }

      .dx-label-before {
        border-radius: ${themeVariables["input-border-radius"]} 0 0
          ${themeVariables["input-border-radius"]} !important;
      }

      .dx-label-after {
        border-radius: 0 ${themeVariables["input-border-radius"]}
          ${themeVariables["input-border-radius"]} 0 !important;
      }
    }

    &.dx-editor-filled {
      border: ${themeVariables["input-filled-border"]};
      color: ${themeVariables["input-filled-color"]} !important;
      background-color: ${themeVariables["input-filled-bg"]} !important;
      border-radius: ${themeVariables["input-border-radius"]};

      .dx-placeholder {
        color: ${themeVariables["input-filled-color"]} !important;
      }

      .dx-icon-search::before {
        color: ${themeVariables["input-filled-color"]} !important;
      }
    }

    &:not(.dx-texteditor-empty):not(.dx-state-active):not(.dx-state-focused):not(.error):not(
        .active
      ) {
      .dx-label,
      .dx-label-after,
      .dx-label-before {
        border-color: ${themeVariables["input-border"]} !important;
        color: ${themeVariables["input-color-label"]} !important;
      }
    }
  }
`;
export const dxEditorFocus = css `
  .dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-focused::after {
    border-color: ${themeVariables["input-border-focus"]} !important;
  }
  .dx-texteditor {
    &.dx-state-active,
    &.dx-state-focused,
    &.active {
      &.dx-editor-filled {
        border-color: ${themeVariables["input-border-focus"]} !important;
        border-width: 2px !important;
        background: ${themeVariables["input-filled-bg-active"]} !important;
      }
      &.dx-editor-outlined {
        border-color: ${themeVariables["input-border-focus"]} !important;

        .dx-label,
        .dx-label-after,
        .dx-label-before {
          border-color: ${themeVariables["input-border-focus"]} !important;
          color: ${themeVariables["input-color-label-focus"]} !important;
        }
      }
    }
  }
`;
export const dxEditorError = css `
  .dx-texteditor.error {
    &.dx-editor-outlined {
      .dx-label,
      .dx-label-after,
      .dx-label-before {
        border-color: ${themeVariables["input-border-error"]} !important;
        color: ${themeVariables["input-border-error"]} !important;
      }

      &.dx-state-active,
      &.dx-state-focused,
      &.active {
        .dx-label {
          border-width: 0 0 2px 0 !important;
        }

        .dx-label-after {
          border-width: 2px 2px 2px 0 !important;
        }

        .dx-label-before {
          border-width: 2px 0 2px 2px !important;
        }
      }
    }
  }
`;
export const dxEditorHover = css `
  .dx-datagrid-filter-range-overlay .dx-overlay-content .dx-texteditor.dx-state-hover::after {
    border-color: ${themeVariables["input-border-hover"]} !important;
  }
  .dx-texteditor.dx-state-hover {
    :not(.dx-state-focused):not(.dx-state-active):not(.error):not(.active) {
      &.dx-editor-outlined {
        border-color: ${themeVariables["input-border-hover"]} !important;
        .dx-label,
        .dx-label-after,
        .dx-label-before {
          border-color: ${themeVariables["input-border-hover"]} !important;
          color: ${themeVariables["input-color-label-hover"]} !important;
        }
      }

      &.dx-editor-filled,
      &.dx-datagrid-search-panel {
        border: ${themeVariables["input-filled-border"]};
        background: ${themeVariables["input-filled-bg-hover"]} !important;
        cursor: pointer !important;
      }
    }
  }
`;
export const dxEditorSearchPanel = css `
  .datagrid-toolbar-search-panel,
  .dx-list-with-search,
  .dx-treeview-with-search {
    .dx-editor-outlined {
      border: ${themeVariables["input-filled-border"]} !important;
      color: ${themeVariables["input-filled-color"]} !important;
      background-color: ${themeVariables["input-filled-bg"]} !important;
      border-radius: ${themeVariables["input-border-radius"]} !important;
      heigth: 36px;

      .dx-label,
      .dx-label-after,
      .dx-label-before {
        border-color: transparent !important;
      }

      .dx-placeholder {
        color: ${themeVariables["input-filled-color"]} !important;
      }

      .dx-icon-search::before {
        color: ${themeVariables["input-filled-color"]} !important;
      }

      &.dx-state-focused,
      &.dx-state-active {
        border-color: ${themeVariables["input-border-focus"]} !important;
        background: ${themeVariables["input-filled-bg-active"]} !important;
      }

      &.dx-state-hover {
        background: ${themeVariables["input-filled-bg-hover"]} !important;
      }
    }
  }
`;
export const dxTooltip = css `
  .dx-tooltip-wrapper.dx-popover-wrapper .dx-popover-arrow::after {
    // border: 1px solid #112232 !important;
    display: none !important;
  }
`;
export const dxIcons = css `
  .dx-datagrid.dx-filter-menu .dx-icon,
  .dx-datagrid.dx-filter-menu .dx-menu-item-has-icon .dx-icon {
    color: ${themeVariables["default-icon-color"]} !important;
  }

  .dx-icon-filter-operation-contains:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e992" !important;
  }
  .dx-icon-filter-operation-not-contains:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e990" !important;
  }
  .dx-icon-filter-operation-starts-with:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e993" !important;
  }
  .dx-icon-filter-operation-ends-with:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e991" !important;
  }
  .dx-submenu .dx-icon-filter-operation-default:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e973" !important;
  }
  .dx-icon-selectall:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e994" !important;
  }
  .dx-icon-unselectall:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e995" !important;
  }
  .dx-icon-filter-operation-between:before {
    font: ${themeVariables["icomoon-icons"]};
    content: "\\e9a0" !important;
  }

  .dxre-icon-FontColor:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99f" !important;
  }

  .dxre-icon-Bookmark:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e996" !important;
  }

  .dxre-icon-TextWrapSquare:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9e4" !important;
  }

  .dxre-icon-IndentDecrease:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9a1" !important;
  }

  .dxre-icon-IndentIncrease:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9a2" !important;
  }

  .dxre-icon-Copy:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e994" !important;
  }

  .dxre-icon-Paste:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e997" !important;
  }

  .dxre-icon-Hyperlink:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e999" !important;
  }

  .dxre-icon-Cut:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99a" !important;
  }

  .dxre-icon-SelectAll:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99b" !important;
  }

  .dxre-icon-FloatingObjectSendBackward:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99c" !important;
  }

  .dxre-icon-FloatingObjectBringForward:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99d" !important;
  }

  .dxre-icon-Paragraph:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e99e" !important;
  }

  .dxre-icon-AlignCenter:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b1" !important;
  }

  .dxre-icon-AlignJustify:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b2" !important;
  }

  .dxre-icon-AlignLeft:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b3" !important;
  }

  .dxre-icon-AlignRight:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b4" !important;
  }

  .dxre-icon-Bookmark:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b5" !important;
  }

  .dxre-icon-ChangeFontStyle:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b6" !important;
  }

  .dxre-icon-ChangeTextCase:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b7" !important;
  }

  .dxre-icon-ClearFormatting:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b8" !important;
  }

  .dxre-icon-Find:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9b9" !important;
  }

  .dxre-icon-FontSizeDecrease:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9ba" !important;
  }

  .dxre-icon-FontSizeIncrease:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9bb" !important;
  }

  .dxre-icon-Footer:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9bc" !important;
  }

  .dxre-icon-Header:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9bd" !important;
  }

  .dxre-icon-InsertImage:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9be" !important;
  }

  .dxre-icon-InsertPageCount:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9bf" !important;
  }

  .dxre-icon-InsertPageNumber:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c0" !important;
  }

  .dxre-icon-InsertTable:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c1" !important;
  }

  .dxre-icon-InsertTextBox:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c2" !important;
  }

  .dxre-icon-LineSpacing:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c3" !important;
  }

  .dxre-icon-ListBullets:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c4" !important;
  }

  .dxre-icon-ListMultilevel:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c5" !important;
  }

  .dxre-icon-ListNumbers:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c6" !important;
  }

  .dxre-icon-New:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c7" !important;
  }

  .dxre-icon-Open:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c8" !important;
  }

  .dxre-icon-Redo:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9c9" !important;
  }

  .dxre-icon-Replace:before,
  .dxre-icon-ViewMergedData:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9ca" !important;
  }

  .dxre-icon-Save:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9cb" !important;
  }

  .dxre-icon-Undo:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9cc" !important;
  }

  .dxre-icon-Print:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9cd" !important;
  }

  .dxre-icon-Download:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9a4" !important;
  }

  .dxre-icon-AlignFloatingObjectBottomCenter:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9ce" !important;
  }

  .dxre-icon-AlignFloatingObjectBottomLeft:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9cf" !important;
  }

  .dxre-icon-AlignFloatingObjectBottomRight:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d0" !important;
  }

  .dxre-icon-AlignFloatingObjectMiddleCenter:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d1" !important;
  }

  .dxre-icon-AlignFloatingObjectMiddleLeft:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d2" !important;
  }

  .dxre-icon-AlignFloatingObjectMiddleRight:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d3" !important;
  }

  .dxre-icon-AlignFloatingObjectTopCenter:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d4" !important;
  }

  .dxre-icon-AlignFloatingObjectTopLeft:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d5" !important;
  }

  .dxre-icon-AlignFloatingObjectTopRight:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d6" !important;
  }

  .dxre-icon-ClearHeaderAndFooter:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d7" !important;
  }

  .dxre-icon-FloatingObjectBringInFrontOfText:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d8" !important;
  }

  .dxre-icon-FloatingObjectBringToFront:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9d9" !important;
  }

  .dxre-icon-FloatingObjectSendBehindText:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9da" !important;
  }

  .dxre-icon-FloatingObjectSendToBack:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9db" !important;
  }

  .dxre-icon-TextWrapBehind {
    position: relative;
    &:after {
      font: ${themeVariables["icomoon-icons"]} !important;
      content: "\\e9dc" !important;
      z-index: 2;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:before {
      font: ${themeVariables["icomoon-icons"]} !important;
      content: "\\e9dd" !important;
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #8895a1 !important;
    }
  }

  .dxre-icon-TextWrapInFrontOfText:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9de" !important;
  }

  .dxre-icon-TextWrapInline:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9df" !important;
  }

  .dxre-icon-TextWrapSquare:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9e0" !important;
  }

  .dxre-icon-TextWrapThrough:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9e1" !important;
  }

  .dxre-icon-TextWrapTight:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9e2" !important;
  }

  .dxre-icon-TextWrapTopAndBottom:before {
    font: ${themeVariables["icomoon-icons"]} !important;
    content: "\\e9e3" !important;
  }
`;
export const dxMenu = css `
  .dx-menu-item.dx-state-focused::after,
  .dx-menu-item-wrapper.dx-state-focused::after {
    border: none !important;
  }
  .dx-filterbuilder-overlay.dx-filterbuilder-operations .dx-treeview-item .dx-icon {
    color: inherit !important;
  }
  .dx-editor-with-menu {
    padding: 0 8px 0;

    .dx-menu {
      padding: 0 8px;
    }
  }
  .dx-editor-with-menu .dx-menu {
    .dx-menu-item {
      &.dx-menu-item-has-icon.dx-menu-item-has-submenu {
        .dx-item-content {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 !important;
        }
        height: 28px;
        width: 28px;
        background-color: ${themeVariables["editor-menu-btn-bg"]} !important;
        color: ${themeVariables["editor-menu-btn-color"]} !important;
        border-radius: ${themeVariables["editor-menu-btn-radius"]} !important;
        .dx-icon {
          margin: 0 !important;
          &::before {
            font-size: 12px;
          }
        }
        &:hover {
          background-color: ${themeVariables["editor-menu-btn-hover-bg"]} !important;
          color: ${themeVariables["editor-menu-btn-hover-color"]} !important;
        }

        .dx-context-menu-container-border {
          border: 0;
          visibility: hidden;
        }

        &.dx-menu-item-expanded {
          background-color: ${themeVariables["editor-menu-btn-active-bg"]} !important;
          color: ${themeVariables["editor-menu-btn-active-color"]} !important;
        }
      }
    }
  }

  .dx-filterbuilder-overlay,
  .dx-filterbuilder-operations {
    .dx-item dx-treeview-item {
      color: black;
    }
  }
`;
export const dxFilterBuilder = css `
  .dx-filterbuilder {
    .dx-filterbuilder-group-item {
      > div,
      > div .dx-filterbuilder-item-value-text {
        min-height: ${themeVariables["filter-builder-item-height"]};
        min-width: ${themeVariables["filter-builder-item-width"]} !important;
        border-radius: ${themeVariables["filter-builder-item-radius"]};
        align-content: center;
        text-align: center;
      }
    }

    .dx-filterbuilder-text.dx-filterbuilder-item-operation {
      background-color: ${themeVariables["filter-builder-item-operation-bg"]} !important;
      color: ${themeVariables["filter-builder-item-operation-color"]} !important;
      transition: all 0.3s ease;

      &:hover {
        background-color: ${themeVariables["filter-builder-item-operation-hover-bg"]} !important;
        color: ${themeVariables["filter-builder-item-operation-hover-color"]} !important;
      }

      &.dx-state-active,
      &:active {
        background-color: ${themeVariables["filter-builder-item-operation-active-bg"]} !important;
        color: ${themeVariables["filter-builder-item-operation-active-color"]} !important;
      }
    }

    .dx-filterbuilder-group-item-operation {
      background-color: ${themeVariables["filter-builder-group-operation-bg"]} !important;
      color: ${themeVariables["filter-builder-group-operation-color"]} !important;

      &:hover {
        background-color: ${themeVariables["filter-builder-group-operation-hover-bg"]} !important;
        color: ${themeVariables["filter-builder-group-operation-hover-color"]} !important;
      }

      &.dx-state-active {
        background-color: ${themeVariables["filter-builder-group-operation-active-bg"]} !important;
        color: ${themeVariables["filter-builder-group-operation-active-color"]} !important;
      }
    }

    .dx-filterbuilder-item-field {
      background-color: ${themeVariables["filter-builder-item-field-bg"]} !important;
      color: ${themeVariables["filter-builder-item-field-color"]} !important;

      &:hover {
        background-color: ${themeVariables["filter-builder-item-field-hover-bg"]} !important;
        color: ${themeVariables["filter-builder-item-field-hover-color"]} !important;
      }

      &.dx-state-active {
        background-color: ${themeVariables["filter-builder-item-field-active-bg"]} !important;
        color: ${themeVariables["filter-builder-item-field-active-color"]} !important;
      }
    }

    .dx-filterbuilder-action-icon,
    .dx-filterbuilder-action {
      &.dx-icon-plus {
        background-color: ${themeVariables["filter-builder-icon-plus-bg"]};
        color: ${themeVariables["filter-builder-icon-plus-color"]};

        &:hover,
        &:focus {
          background-color: ${themeVariables["filter-builder-icon-plus-hover-bg"]};
          color: ${themeVariables["filter-builder-icon-plus-hover-color"]};
        }
        &.dx-state-active,
        &:active {
          background-color: ${themeVariables["filter-builder-icon-plus-active-bg"]};
          color: ${themeVariables["filter-builder-icon-plus-active-color"]};
        }
      }
      &.dx-icon-remove {
        background-color: ${themeVariables["filter-builder-icon-remove-bg"]};
        color: ${themeVariables["filter-builder-icon-remove-color"]};

        &:hover,
        &:focus {
          background-color: ${themeVariables["filter-builder-icon-remove-hover-bg"]};
          color: ${themeVariables["filter-builder-icon-remove-hover-color"]};
        }
        &.dx-state-active,
        &:active {
          background-color: ${themeVariables["filter-builder-icon-remove-active-bg"]};
          color: ${themeVariables["filter-builder-icon-remove-active-color"]};
        }
      }
    }
  }
`;
export const dxReverseBtnOkCannel = css `
  .dx-toolbar-after {
    &:has(
        > .dx-toolbar-item:first-child
          > .dx-toolbar-item-content
          > .dx-button[aria-label="${locale.OK}"]
      ),
    &:has(
        > .dx-toolbar-item:first-child
          > .dx-toolbar-item-content
          > .dx-button[aria-label="${locale["dxDataGrid-headerFilterOK"]}"]
      ),
    &:has(
        > .dx-toolbar-item:first-child
          > .dx-toolbar-item-content
          > .dx-button[aria-label="${locale["ASPxRichEditStringId.OkButton"]}"]
      ) {
      display: flex;
      flex-flow: row-reverse;
      gap: 8px;
      padding: 0;
      .dx-toolbar-item {
        padding: 0;
        .dx-button {
          padding: 8px 24px;
          height: ${themeVariables["input-height-medium"]};
          .dx-button-text {
            font-size: 14px;
          }
        }
      }
    }
  }
`;
export const dxColorBox = css `
  .dx-colorbox-color-result-preview {
    border-radius: ${themeVariables["color-result-preview-border-radius"]};
    border-color: ${themeVariables["color-result-preview-border-color"]};
  }
`;
